import { createAction, props } from '@ngrx/store';
import { QueryParams, QueryResult } from '../../../core/store/models/query.model';
import { SecurityGroup, SecurityGroupType } from './security-group.model';
import { SecurityGroupMember } from './security-group-member.model';
import { SecurityGroupPermissionSetItem } from './security-group-permission-set-item.model';
import { User } from '../users/user.model';

//
// Security Group Page actions
//
export const newSecurityGroup = createAction('[Security_Group/Page] New Security Group');
export const removeSecurityGroup = createAction('[Security_Group/Page] Remove Security Group', props<{ uId: string }>());
export const addSecurityGroup = createAction('[Security_Group/Page] Add Security Group', props<{ securityGroup: SecurityGroup }>());
export const updateSecurityGroup = createAction('[Security_Group/Page] Update Security Group', props<{ securityGroup: SecurityGroup }>());
export const setSelectedSecurityGroup = createAction('[Security_Group/Page] Set Selected Security Group', props<{ uId: string }>());
export const setSelectedSecurityGroupComplete = createAction(
  '[Security_Group/Page] Set Selected Security Group Complete',
  props<{ uId: string }>()
);
export const setSelectedEditSection = createAction('[Security_Group/Page] Set Security Group Section', props<{ sectionName: string }>());
export const showSecurityGroupForm = createAction(
  '[Security_Group/Page] Show Security Group Form',
  props<{ showSecurityGroupForm: boolean }>()
);
export const cancelEditSecurityGroup = createAction('[Security_Group/Page] Cancel Edit Security Group');
export const cancelEditSecurityGroupComplete = createAction('[Security_Group/Page] Cancel Edit Security Group Complete');
export const setSecurityGroupForDelete = createAction('[Security_Group/Page] Set Security Group For Delete', props<{ uId: string }>());
export const clearSecurityGroupForDelete = createAction('[Security_Group/Page] Clear Security Group For Delete');
export const setPermissionSetItems = createAction(
  '[Security_Group/Page] Set Selected Security Group Permission Set Items',
  props<{ permissionSets: SecurityGroupPermissionSetItem[] }>()
);
export const showAddMembersForm = createAction('[Security_Group/Page] Show Add Members Form', props<{ showAddMembersForm: boolean }>());
export const loadSelectedSecurityGroup = createAction('[Security_Group/Page] Load Selected Security Group', props<{ securityGroup: SecurityGroup }>());

//
// Security Group API actions
//
export const setError = createAction('[Security_Group/API] Set Error', props<{ err: Error }>());
export const getSecurityGroups = createAction('[Security_Group/API] Get Security Groups');
export const loadSecurityGroups = createAction(
  '[Security_Group/API] Load Security Groups',
  props<{ results: QueryResult<SecurityGroup> }>()
);
export const saveSecurityGroup = createAction('[Security_Group/API] Save Security Group', props<{ securityGroup: SecurityGroup }>());
export const deleteSelectedSecurityGroup = createAction('[Security_Group/API] Delete Selected Security Group');
export const getSelectedSecurityGroupMembers = createAction(
  '[Security_Group/API] Get Selected Security Group Members',
  props<{ params: Partial<QueryParams> }>()
);
export const loadSelectedSecurityGroupMembers = createAction(
  '[Security_Group/API] Load Selected Security Group Members',
  props<{ results: QueryResult<SecurityGroupMember> }>()
);
export const getPermissionSets = createAction('[Security_Group/API] Get Selected Security Group Permission Sets');
export const loadPermissionSets = createAction(
  '[Security_Group/API] Load Selected Security Group Permission Sets',
  props<{ permissionSets: SecurityGroupPermissionSetItem[] }>()
);
export const savePermissionSets = createAction(
  '[Security_Group/API] Save Selected Security Group Permission Sets',
  props<{ permissionSets: SecurityGroupPermissionSetItem[] }>()
);
export const clearPermissionSet = createAction('[Security_Group/State] Clear Permission Set');
export const savePermissionSetsComplete = createAction('[Security_Group/API] Save Selected Security Group Permission Sets Complete');
export const addMembers = createAction('[Security_Group/API] Add Members to Security Group', props<{ users: User[] }>());
export const addMembersComplete = createAction('[Security_Group/API] Add Members to Security Group Complete');
export const removeMember = createAction('[Security_Group/API] Remove Member from Security Group', props<{ uId: string }>());
export const removeMemberComplete = createAction('[Security_Group/API] Remove Member from Security Group Complete');

export const changeTypeFilter = createAction(
  '[Security_Group/State] Change Type Filter',
  props<{ securityGroupTypeFilter: SecurityGroupType }>()
);
export const searchSecurityGroups = createAction('[Security_Group/State] Search', props<{ searchTerm: string }>());

export const updateQueryParams = createAction('[Security Group/State] Update Query Params', props<{ updates: Partial<QueryParams> }>());
